import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import { COOKIE_CONSENT_KEY, setCookieConsent } from "@/lib/cookieConsent";

const HIDDEN_PATHS = ["/client-dashboard", "/dashboard"];

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent && !HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) {
      setShowBanner(true);
    } else if (HIDDEN_PATHS.some(p => location.pathname.startsWith(p))) {
      setShowBanner(false);
    }
  }, [location.pathname]);

  const handleAccept = () => {
    setCookieConsent("accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    setCookieConsent("declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  const banner = (
    <div className="fixed left-0 right-0 bottom-4 z-[9999] px-4 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="container mx-auto max-w-2xl">
        <div className="bg-card/95 backdrop-blur-md border border-border rounded-xl shadow-xl p-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-sm text-muted-foreground text-center sm:text-left">
              We use cookies to enhance your experience.{" "}
              <Link to="/privacy-policy" className="text-primary underline hover:no-underline">
                Learn more
              </Link>
            </p>
            <div className="flex gap-2 shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={handleDecline}
                className="rounded-md text-xs px-3"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={handleAccept}
                className="rounded-md text-xs px-3 bg-primary hover:bg-primary/90"
              >
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Use portal to render outside scroll-snap container
  return createPortal(banner, document.body);
};

export default CookieConsent;
